import styles from './MapWithCompetitors.module.css'
import { APIProvider } from '@vis.gl/react-google-maps'
import { Map } from '@vis.gl/react-google-maps'
import { HostServiceMarker } from './presentationals/HostServiceMarker'
import { CSSProperties, useCallback, useEffect, useState } from 'react'
import { HostServiceDetailWindow } from './presentationals/HostServiceDetailWindow'
import { MapCameraChangedEvent, MapCameraProps } from '@vis.gl/react-google-maps';
import classNames from 'classnames'
import { CircularProgress } from '@mui/material'
import { useMediaQuery } from 'usehooks-ts'
import { BreakPointsWidth } from '../../../../../../../shared/enums/BreakPointsWidth'

const INITIAL_CAMERA = {
    center: { lat: 40.78, lng: -73.95},
    zoom: 14
}

const API_KEY = `AIzaSyDX87U6r9-PPzM5R57-2eAkgJhy6lLUGgE`

interface MapWithCompetitorsProps{
    count? : number
    hostServices?: any[]
    selectedHostServices?: any[]
    onMarkerClick?: (hostService: any) => void
    onCloseDetailWindow: (event: any) => void
    onStartPropertySpy: (event: any) => void
    onStopPropertySpy: (event: any) => void
    spyId?: number
    loading?: boolean
}

export const MapWithCompetitors = (props: MapWithCompetitorsProps): JSX.Element => {
    const { 
        hostServices,
        selectedHostServices,
        spyId,
        onMarkerClick,
        onStartPropertySpy,
        onStopPropertySpy,
        onCloseDetailWindow,
        loading
    } = props

    const isMediumOrMoreDevice = useMediaQuery(`only screen and (min-width : ${BreakPointsWidth.md}px)`)

    const handleMarkerClick = (event: any) => {
        onMarkerClick?.(event)
    }

    const markers = hostServices && hostServices?.map((hostService, index) => {
        const selected = selectedHostServices?.some((selectedHostService) => selectedHostService.id === hostService.id  )

        return (
            <HostServiceMarker
                key={hostService.id}
                hostService={hostService}
                onClick={handleMarkerClick}
                selected={selected}
                index={index}
            />
        )
    })

    const windows = selectedHostServices && selectedHostServices?.map((hostService) => {
        const index = hostServices?.findIndex((allhs) => allhs.id === hostService.id) || 0

        return (
            <HostServiceDetailWindow
                key={hostService.id}
                hostService={hostService}
                spyId={spyId}
                onStartPropertySpy={onStartPropertySpy}
                onStopPropertySpy={onStopPropertySpy}
                onClose={onCloseDetailWindow}
                index={index}
            />
        )
    })

    const mapStyle: CSSProperties = {
        borderRadius: '16px',
        background: '#FFF',
        overflow: 'auto',
    }

    const [cameraProps, setCameraProps] = useState<MapCameraProps>(INITIAL_CAMERA);

    useEffect(() => {
        if (hostServices !== undefined && hostServices.length > 0) {

            const longitudeadjustment = isMediumOrMoreDevice === true ? 0.5 : 0

            setCameraProps((prev: any) => {
                return {
                    ...prev,
                    center: {
                        lat: hostServices[0].latitude,
                        lng: hostServices[0].longitude - longitudeadjustment
                    }
                }
            })
        }
    }, [
        hostServices,
        isMediumOrMoreDevice
    ])

    const handleCameraChange = useCallback((ev: MapCameraChangedEvent) => {
        setCameraProps(ev.detail)
    }, []
    );

    const mapWithCompetitorsLoaderClasses = classNames(styles.MapWithCompetitors__Loader, {
        [styles.MapWithCompetitors__Loader__Show]: loading,
    })

    const mapWithCompetitorsLoaderBgClasses = classNames(styles.MapWithCompetitors__Loader__Bg, {
        [styles.MapWithCompetitorsLoader__Bg__Show]: loading,
    })

    return (
        <div className={styles.MapWithCompetitors__Root}>
            <div className={mapWithCompetitorsLoaderClasses}>
                <div className={mapWithCompetitorsLoaderBgClasses}></div>
                <div className={styles.MapWithCompetitors__Loader__Spinner}>
                    <div>Loading</div>
                    <div><CircularProgress size={80} /></div>
                </div>
            </div>
            <APIProvider apiKey={API_KEY}>
                <Map    
                    style={mapStyle}
                    mapId={'a36892df908962b433b2ea6e'}
                    {...cameraProps}
                    gestureHandling={'greedy'}
                    disableDefaultUI
                    onCameraChanged={handleCameraChange}
                >

                </Map>
            </APIProvider>
        </div>
    )
}